import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { EmployeeTypeStateClass } from "./interfaces/EmployeeTypeStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { sortData } from "../../../common/timeLiveFunction";


const initialState: EmployeeTypeStateClass = {
    isLoading: true,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    employeeTypeList: [],
    sortOrder: 'asc',
    sortColumn: 'AccountEmployeeType',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        employeeType: EmployeeTypeStateClass
    }
}

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getAccountEmployeeTypeByAccountEmployeeTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeTypeByAccountEmployeeTypeId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/addAccountEmployeeType",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/EmployeeTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/updateAccountEmployeeType",
        async (arg, thunkApi) => {
            const { AccountEmployeeTypeId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/"+AccountEmployeeTypeId,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/" + AccountEmployeeTypeId, "PUT", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/deleteAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const DeleteSelectedAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/DeleteSelectedAccountEmployeeType",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/EmployeeTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const employeeTypeSlice = createSlice({
    name: "employeeType",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.employeeTypeList.findIndex((item) => item.AccountEmployeeTypeId == action.payload);
            const newArray = [...state.employeeTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.employeeTypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.employeeTypeList.findIndex((item) => item.AccountEmployeeTypeId == action.payload);
            const newArray = [...state.employeeTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.employeeTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.employeeTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.employeeTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.employeeTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.employeeTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.employeeTypeList;
            state.employeeTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

                state.status = "idle";
                //state.employeeTypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.employeeTypeList = [];
                } else {
                    state.employeeTypeList = payload.Data;
                    state.employeeTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;

            })

            .addCase(getAccountEmployeeTypeByAccountEmployeeTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeByAccountEmployeeTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                //state.selectedRecord = payload[0];
                
            })
            .addCase(getAccountEmployeeTypeByAccountEmployeeTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(addAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updateAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(deleteAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


            .addCase(DeleteSelectedAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination } = employeeTypeSlice.actions
export const EmployeeTypeState = (state: RootState) => state.employeeType
export default employeeTypeSlice.reducer


